const initialState = () => ({
  adminReg: {
    id: "",
    orgID: "",
    person: {
      id: "",
      firstName: "",
      lastName: "",
      email: "",
      gender: "",
      cellPhone: ""
    },
    status: "",
    address: {
      id: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      country: "",
      zipCode: ""
    }
  }
})

const state = initialState()

const getters = {
  adminReg: (state) => state.adminReg
}

const mutations = {
  RESET_ADMIN_REG(state) {
    Object.assign(state, initialState())
  },
  SET_ADMIN_REG(state, adminReg) {
    state.adminReg = adminReg
  }
}

const actions = {
  clearAdminReg({ commit }) {
    commit("RESET_ADMIN_REG")
  },
  setAdminReg({ commit }, adminReg) {
    commit("SET_ADMIN_REG", adminReg)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
